import React from 'react';
import { AlertCircle } from 'lucide-react';

const ErrorState: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-red-600 to-red-800 flex items-center justify-center">
      <div className="text-center text-white max-w-md mx-auto p-8">
        <AlertCircle className="h-16 w-16 mx-auto mb-4" />
        <h1 className="text-2xl font-bold mb-2">Sorteio não encontrado</h1>
        <p className="text-red-100">
          O sorteio que você está procurando não existe ou não está ativo.
        </p>
      </div>
    </div>
  );
};

export default ErrorState;
